import { RowKebabMenu, RowKebabMenuItem } from '@/Client/Widgets';

/* Duplicate and Delete, behind a kebab that appears on hover — the design call from the
   Aug 19 review. They used to live in the editor tab, which meant selecting a task before
   you could act on it; the navigator is where you are when you decide. Group headers carry
   the same kebab for the same reason, in place of the old copy-mode gear toggle. */

/**
 * Duplicate and Delete for one row — a task row or a group header.
 *
 * Renders nothing when neither action is available, so a locked scope and the CloseoutReviewFlow
 * host (which passes no row actions) keep the row exactly as it was.
 */
export const KaiNavRowMenu = ({
  label,
  onDelete,
  onDuplicate,
  alwaysVisible = false,
}: {
  /** The row's own name — the task's title, or the group's — used only for the trigger's
   *  accessible name ("Actions for {label}"). */
  label: string;
  onDelete?: () => void;
  onDuplicate?: () => void;
  /** Skips the hover/focus reveal — the trigger stays visible outright. The host row's own
   *  gutter must be open to match (KEBAB_GUTTER_OPEN_STYLE), or this sits over whatever the
   *  gutter would otherwise have opened for. */
  alwaysVisible?: boolean;
}) => {
  const items: RowKebabMenuItem[] = [
    ...onDuplicate ? [{ label: 'Duplicate', onSelect: onDuplicate }] : [],
    ...onDelete ? [{ label: 'Delete', onSelect: onDelete, destructive: true }] : [],
  ];
  return <RowKebabMenu label={label} items={items} alwaysVisible={alwaysVisible} />;
};
